
import Vue from 'vue';
import RadioButton from '~/components/common/RadioButton/RadioButton.vue';

export default Vue.extend({
  name: 'RadioButtonGroup',
  components: {
    RadioButton,
  },
  props: {
    config: {
      type: Array,
      default: () => [],
      required: true,
    },
    group: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleChange({ value }: { value: unknown }) {
      this.$emit('change', value);
    },
  },
});
